<template>
        <div class="container" >
            <div class="row">
                <div class="col-md-12">
                    <h3>{{ $t('pages.changeversion') }}</h3>
                    <div class="cards">
                        <!-- Tab panes -->
                        <div class="tab-contents" @scroll="handleScroll" >
                            <table class="datatable">
                                <thead>
                                <tr>
                                    <th>Версия</th>
                                    <th>Описание</th>
                                    <th>Дата</th>
                                    <th>Кто сделал</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="log in logs" :key='log.id'>
                                        <td>{{log.version}}</td>
                                        <td v-html="htmlNow(log.description)"></td>
                                        <td>{{log.date}}</td>
                                        <td>{{log.by_user}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
  import API from '@/api/API'

  export default {
    name: 'ChangeVersion',
    data: function () {
      return {
        logs: [],
        isline: false,
        selecteds: 1,
        perpage: 15,
        page: 1,
        count_page: 1,
        loading: false
      }
    },
    mounted: function () {
      API.getChangeVersion(1, this.perpage).then(response => {
        var json = response.data
        var logs = json.items
        this.logs = logs
        this.page++
        this.count_page = json.count_pages
      }).catch()
    },
    methods: {
      showlistclick (num) {
        this.page = 1
        this.selecteds = num
        this.loading = true
        API.getChangeVersion(this.page, this.perpage).then(response => {
          var json = response.data
          var logs = json.items
          this.logs = logs
          this.page++
          this.loading = false
        }).catch()
      },
      showlist () {
        this.loading = true
        API.getChengeLog(this.selecteds, this.page, this.perpage).then(response => {
          var json = response.data
          var logs = json.items
          this.logs = this.logs.concat(logs)
          console.log(this.page)
          this.page++
          this.loading = false
        }).catch()
      },
      handleScroll (event) {
        var diff = window.scrollY + event.target.firstElementChild.clientHeight
        var documentHeight = event.target.firstElementChild.offsetHeight
        if (diff > documentHeight && this.page <= this.count_page && !this.loading) {
          this.showlist()
        }
      },
      htmlNow: function (text) {
        let textNew = text.replace(/\n/g, '<br />')
        return textNew
      }
    },
    beforeMount: function () {
      window.scrollTo(0, 0)
    },
    created: function () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed: function () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>


<style>
.nav-tabs {
    border-bottom: 2px solid #DDD;
  }
.nav-tabs {
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}
.nav-tabs>li {
  margin-bottom: -1px;
  position: relative;
  display: inline-block;
}
.nav-tabs>li>span {
  display: block;
  padding: 10px 15px;
  text-decoration: none;
  cursor: pointer;
}
.nav-tabs>li.active>span,.nav-tabs>li.active>span:focus,.nav-tabs>li.active>span:hover {
  border-width: 0;
}
.nav-tabs>li>span {
  border: none;
  color: #666;
}
.nav-tabs>li.active>span,.nav-tabs>li>span:hover {
  border: none;
  color: #4285F4 !important;
  background: transparent;
}
  
.nav-tabs>li>span::after {
  content: "";
  background: #4285F4;
  height: 2px;
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: -1px;
  -webkit-transition: all 250ms ease 0s;
  transition: all 250ms ease 0s;
  -webkit-transform: scale(0);
  transform: scale(0);
  }
  
  .nav-tabs>li.active>span::after,.nav-tabs>li:hover>span::after {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  
  .tab-nav>li>a::after {
    background: #21527d none repeat scroll 0% 0%;
    color: #fff;
  }
  .tab-pane {
    padding: 15px 0;
  }
  .tab-contents {
    padding: 20px
  }
  .cards {
    background: #FFF none repeat scroll 0% 0%;
    -webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
            box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    margin-bottom: 30px;
    margin-top: 20px;
  }
  .datatable{
    width: 100%;
  }
  .datatable tbody tr:hover {
    background-color: #EEE;
  }
  .datatable tr td {
    padding: 10px 0 10px 56px;
    height: 48px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.87);
    border-bottom: solid 1px #DDDDDD;
    text-overflow: ellipsis;
    max-width: 450px;
    word-wrap: break-word;
  }
  .datatable th {
    font-size: 13px;
    font-weight: 700;
    color: #757575;
    cursor: pointer;
    border-bottom: solid 1px #DDDDDD;
    border-top: solid 1px #DDDDDD;
    padding: 0;
    height: 56px;
    padding-left: 56px;
    vertical-align: middle;
    outline: none !important;
  }
</style>



// WEBPACK FOOTER //
// ChangeVersion.vue?a914b8c0